export default "__VITE_ASSET__QGpE8b4r__"